export const FORM_NAME = "ForgotPin";
export const STATE_NAME = "forgotPinScreen";
